/* eslint-disable prefer-destructuring */
import { createListenerMiddleware, isAnyOf, isRejected } from '@reduxjs/toolkit';
import { uniqBy } from 'lodash-es';
import { LOCATION_SLICE_NAME } from 'store/slices/slicesNames';
import { executeSearch } from 'store/slices/results/resultsThunks';
import { fetchDefaultLocationFromZipcode } from 'store/slices/location/locationThunks';

import { actions } from 'store/toolkit';
import { isEmbedded } from 'utils/utils';
import {
  isInvalidTokenRejection,
  isTokenRefreshTimeout,
  isInvalidToken,
} from 'store/actionMatchers';
import {
  directionsOpenedFromResultCard,
  directionsOpenedFromProfile,
  phoneClickFromProfile,
  phoneClickFromResultCard,
  faxClickFromProfile,
  faxClickFromResultCard,
  phoneClickFromCompareModal,
  addressClickFromCompareModal,
  directionsClickFromPromotionProfile,
  websiteClickFromPromotionProfile,
  accessAppLinkFromPromotionProfile,
  accessChatLinkFromPromotionProfile,
  accessEmailFromPromotionProfile,
  accessPDFfromPromotionProfile,
  phoneClickFromPromotionProfile,
  getStartedClickFromPromotionProfile,
  printProfile,
  printCompareTable,
  printShareCompareTable,
} from 'analytics/analyticsActions';

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(executeSearch.fulfilled, fetchDefaultLocationFromZipcode.fulfilled),
  effect: (action, listenerApi) => {
    const locationHistory = listenerApi.getState()[LOCATION_SLICE_NAME].locationHistory;

    // if a location from history is selected, it's pushed to the front of the locationHistory array
    // therefore we need to remove its duplicate
    const dedupedHistory = uniqBy(locationHistory, 'id');

    if (dedupedHistory.length > 5) dedupedHistory.pop();

    listenerApi.dispatch(actions.location.setLocationHistory(dedupedHistory));

    localStorage.setItem('locationHistory', JSON.stringify(dedupedHistory));
  },
});

// prompt the feedback modal for any of the following actions:
listenerMiddleware.startListening({
  matcher: isAnyOf(
    addressClickFromCompareModal,
    directionsOpenedFromProfile,
    directionsOpenedFromResultCard,
    faxClickFromProfile,
    faxClickFromResultCard,
    phoneClickFromCompareModal,
    phoneClickFromProfile,
    phoneClickFromResultCard,
    directionsClickFromPromotionProfile,
    websiteClickFromPromotionProfile,
    accessAppLinkFromPromotionProfile,
    accessChatLinkFromPromotionProfile,
    accessEmailFromPromotionProfile,
    accessPDFfromPromotionProfile,
    phoneClickFromPromotionProfile,
    getStartedClickFromPromotionProfile,
    printProfile,
    printCompareTable,
    printShareCompareTable
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(actions.ui.promptFeedbackModal());
  },
});

// notifications
if (isEmbedded()) {
  listenerMiddleware.startListening({
    matcher: isRejected(),
    effect: (action, listenerApi) => {
      if (
        isInvalidTokenRejection(action) ||
        isTokenRefreshTimeout(action) ||
        isInvalidToken(action)
      ) {
        listenerApi.dispatch(
          actions.notifications.create({
            message:
              'Your session has expired. Please wait a moment and try again or refresh the page.',
            severity: 'error',
          })
        );
      }
    },
  });
}

export default listenerMiddleware;
